module.exports = __webpack_public_path__ + "5dd7db789e0cf89969a1d7543dcd4bb3.jpg";